import { useMemo } from "react";

import { differenceInDays } from "date-fns";

const SNOOZE_OPTIONS = [
  { days: 1, text: "Mute until tomorrow" },
  { days: 3, text: "Mute for 3 days" },
  { days: 7, text: "Mute for 1 week" },
];

function useSnoozeOptions(expirationDate) {
  return useMemo(() => {
    const daysRemaining = differenceInDays(expirationDate, new Date());

    return SNOOZE_OPTIONS.filter(({ days }) => {
      return days <= daysRemaining;
    });
  }, [expirationDate]);
}

export default useSnoozeOptions;
